export default __webpack_public_path__ + "static/media/gallery-wip-emitter_02.eaa47b5e.jpg";